import { withTranslation } from '@application/i18n/with_translation';
import { Flex, TextLink } from '@cellula/react';
import { tokens } from '@cellula/react-theme-patient';
import { AsyncSignal } from '@cortex-shim/async_signal.component';
import { useResolveController } from '@visiba/instantiation';
import { FooterController } from './footer.controller';

export function LegalLinks() {
	const controller = useResolveController(FooterController);

	// NHS specification requires legal links to open in a new tab.
	return (
		<AsyncSignal signal={controller.data}>
			{({ legal }) => (
				<>
					{legal.length > 0 ? (
						<Flex gap={tokens.spacing.x1}>
							{legal.map((link) => (
								<TextLink key={link.key} href={link.value} target='_blank' icon='linkOut' iconPosition='trailing' size='small'>
									{withTranslation(link.translationKey)}
								</TextLink>
							))}
						</Flex>
					) : null}
				</>
			)}
		</AsyncSignal>
	);
}
